<template>
  <div class="body-wrap">
    <loading-spinner v-if="isLoading"></loading-spinner>
    <transition name="fadeIn">
      <div v-if="showSuccessAlert">
        <success-alert-mobile :message="successMessage"></success-alert-mobile>
      </div>
    </transition>
    <transition name="fadeIn">
      <div v-if="showErrorAlert">
        <danger-alert-mobile :message="errorMessage"></danger-alert-mobile>
      </div>
    </transition>

    <table id="tblWithdraw" class="table">
      <thead>
        <tr class="border-top-bottom-none">
          <th class="border-top-bottom-none" style="width: 30%">
            {{ $t('GameType') }}
          </th>
          <th style="width: 40%" class="text-right border-top-bottom-none">
            {{ $t('GameBalance') }}
          </th>
          <th class="border-top-bottom-none" style="width: 30%">
            <button
              class="CashOut TransferButton btn-restore btn btn-warning"
              :disabled="
                showProgress || isSomeBalanceLaoding || isAllBalanceZero
              "
              @click="onClickRestore()"
            >
              <img
                class="icn-restore"
                src="../../../assets/icons/icn-restore.png"
              />
              <span class="Txt3 text-restore">{{ $t('BtnRestore') }}</span>
            </button>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr class="dim" v-for="(game, index) in gameImport" :key="game.code">
          <template v-if="game.enabled">
            <td class="gamename">{{ game.name }}</td>
            <td class="gamebalance">
              <span class="balance" v-if="game.isProgress || showProgress">
                <i class="fas fa-spinner fa-spin"></i>
                <!-- <div
                id="spin-50"
                class="spin-50 hidden-sm spinner-grow spinner-color"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div> -->
              </span>
              <span v-if="isError">-</span>
              <span
                class="balance cursor-pointer"
                @click="onClickRefreshBalance(index)"
                v-else-if="!game.isProgress && !showProgress"
              >
                {{ $filters.currencyDecimal(game.GameBalance) }}
              </span>
            </td>
            <td v-if="game.Reason != ''">
              <span class="text-danger" v-if="suspend">
                {{ $t('AccountSuspended') }}
              </span>
              <span
                @click="onClickRefreshBalance(index)"
                class="text-danger"
                v-else-if="game.Reason != ''"
              >
                {{ game.Reason }}</span>
            </td>
            <td v-if="game.Reason == ''">
              <button
                class="CashOut TransferButton btn-cashout btn btn-warning"
                id="btn-wd-31"
                :disabled="
                  game.GameBalance <= 0 || game.Reason != '' || game.isProgress
                "
                @click="onClickCashOut(index)"
              >
                <img
                  class="icn-cashout"
                  src="../../../assets/icons/icn-cashout.png"
                  style=""
                />
                <span class="Txt3 text-cashout">{{ $t('BtnCashOut') }}</span>
              </button>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CustomHttp from '../../../CustomHttp';
import CustomStorage from '../../../CustomStorage';
// import CustomEncrypt from '../../../CustomEncrypt';
import GameImport from '../../../assets/script/game';
const gameUrl = process.env.VUE_APP_GAME_URL;
//Vue export
export default {
  mounted() {
    this.gameImport = this.gameImport.filter((x) => x.enabled == true);
    this.gameImport.forEach((item, index) => {
      //  always use gameURl 1 for cashout withdrawal
      this.gameImport[index].gameUrl = gameUrl;
      this.gameImport[index].GameBalance = 0;
      this.gameImport[index].Reason = '';
    });
    this.getUserCashOutDetails();
  },
  data() {
    return {
      isLoading: false,
      showProgress: false,
      isError: false,
      gameImport: JSON.parse(JSON.stringify(GameImport)),
      showSuccessAlert: false,
      showErrorAlert: false,
      successMessage: '',
      errorMessage: '',
    };
  },
  methods: {
    async onClickCashOut(i) {
      // this.isLoading = true;
      this.gameImport[i].isProgress = true;
      const selectedRecord = this.gameImport[i];
      const response = await CustomHttp.withDrawFromGame(
        selectedRecord.code,
        selectedRecord.GameBalance,
        10,
        selectedRecord.gameUrl
      );
      this.isLoading = false;
      if (response.errtext[0] == '') {
        this.onClickRefreshBalance(i);
        this.toggleSuccessAlert('Success Withdraw');
      } else {
        this.toggleDangerAlert(response.errtext[0]);
      }
    },
    async onClickRestore() {
      this.isLoading = true;
      try {
        for (let i = 0; i < this.gameImport.length; i++) {
          if (this.gameImport[i].GameBalance != 0) {
            this.gameImport[i].isProgress = true;
          }
        } //end for loop

        for (let i = 0; i < this.gameImport.length; i++) {
          if (this.gameImport[i].GameBalance != 0) {
            const response = await CustomHttp.withDrawFromGame(
              this.gameImport[i].code,
              this.gameImport[i].GameBalance,
              10,
              this.gameImport[i].gameUrl
            );
            if (response.errtext[0] == '') {
              this.onClickRefreshBalance2(i);
            }
          }
        } //end for loop

        this.toggleSuccessAlert('Success Withdraw');
        this.isLoading = false;
      } catch (error) {
        this.toggleDangerAlert('Failed restore credit');
        this.isLoading = false;
      }
    },
    async onClickRefreshBalance2(i) {
      this.gameImport[i].isProgress = true;
      const selectedRecord = this.gameImport[i];
      try {
        const response = await CustomHttp.getOneGame2(
          selectedRecord.code,
          selectedRecord.gameUrl
        );
        const responseBalance = response.credit[0];
        this.gameImport[i].GameBalance = responseBalance;
        this.gameImport[i].isProgress = false;
        this.gameImport[i].Reason = '';
      } catch (error) {
        let tempMessage = error.message;
        tempMessage = tempMessage.replace('Error:', '');
        this.gameImport[i].GameBalance = 0;
        this.gameImport[i].Reason = tempMessage;
        this.gameImport[i].isProgress = false;
      }
    },
    async onClickRefreshBalance(i) {
      this.gameImport[i].isProgress = true;
      const selectedRecord = this.gameImport[i];
      try {
        const response = await CustomHttp.getOneGame(
          selectedRecord.code,
          10,
          selectedRecord.gameUrl
        );
        const responseBalance = response.credit[0];
        this.gameImport[i].GameBalance = responseBalance;
        this.gameImport[i].isProgress = false;
        this.gameImport[i].Reason = '';
      } catch (err) {
        let tempMessage = err.message;
        tempMessage = tempMessage.replace('Error:', '');
        this.gameImport[i].GameBalance = 0;
        this.gameImport[i].Reason = tempMessage;
        this.gameImport[i].isProgress = false;
      }
    },
    async getUserCashOutDetails() {
      if (this.$store.getters.suspend) {
        return;
      }
      this.showProgress = true;
      //  await this.$store.dispatch('getSession');

      let idListString = '';
      // url 1
      const gameImportUrl1 = this.gameImport.filter(
        (x) => x.gameUrl == gameUrl
      );
      gameImportUrl1.forEach((item, index) => {
        if (this.gameImport.length == index + 1) {
          idListString += item.code;
        } else {
          idListString += item.code + ',';
        }
      });

      let response = await CustomHttp.getAllGame(idListString, gameUrl);
      if (!response.data) {
        this.showProgress = false;
        this.showErrorAlert = true;
        this.isError = true;
        this.errorMessage =
          'Error connecting to server. Please try refreshing the page!';

        return false;
      }
      if (response.data.ErrText != '') {
        this.$swal.fire(response.data.ErrText);
        return;
      }
      let responseData = [];
      // eslint-disable-next-line
      gameImportUrl1.forEach((item, index) => {
        const tempRecord = response.data.game_list.find(
          (l) => l.GameId == item.code
        );
        responseData.push(tempRecord);
      });

      // url 2
      //   let gameImportUrl2 = this.gameImport.filter((x) => x.gameUrl == gameUrl2);
      //   idListString = '';
      //   gameImportUrl2.forEach((item, index) => {
      //     if (this.gameImport.length == index + 1) {
      //       idListString += item.code;
      //     } else {
      //       idListString += item.code + ',';
      //     }
      //   });
      //   let response2 = await CustomHttp.getAllGame(idListString, gameUrl2);
      //   if (response2.data.ErrText != '') {
      //     this.$swal.fire(response2.data.ErrText);
      //     return;
      //   }
      //   gameImportUrl2.forEach((item) => {
      //     const tempRecord = response2.data.game_list.find(
      //       (l) => l.GameId == item.code
      //     );
      //     responseData.push(tempRecord);
      //   });
      this.gameImport.forEach((item, index) => {
        const record = responseData.find((r) => r.GameId == item.code);
        this.gameImport[index] = {
          ...this.gameImport[index],
          ...record,
          isProgress: false,
        };
      }); //end for each

      //end get game from details from API
      this.showProgress = false;
      //   const response = await CustomHttp.post(
      //     '/api/v1/member/get-preference',
      //     json
      //   );
      //   const responseData = response.data.data;
    }, //end getcashout details
    toggleSuccessAlert(message) {
      this.successMessage = message;
      this.showSuccessAlert = true;
      setTimeout(() => {
        this.showSuccessAlert = false;
      }, 1500);
    },
    toggleDangerAlert(message) {
      this.errorMessage = message;
      this.showErrorAlert = true;
      setTimeout(() => {
        this.showErrorAlert = false;
      }, 1500);
    },
  },
  computed: {
    suspend() {
      return this.$store.getters.suspend;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isAllBalanceZero() {
      const flag = this.gameImport.find((g) => g.GameBalance != 0);
      if (flag == undefined) {
        return true;
      } else {
        return false;
      }
    },
    isSomeBalanceLaoding() {
      const flag = this.gameImport.find((g) => g.isProgress == true);
      if (flag == undefined) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    // eslint-disable-next-line
    isLoggedIn(newValue, oldValue) {
      if (newValue == false) {
        this.isLoading = true;
        CustomStorage.setItem('isTimeout', 'true');
        window.location.reload();
      }
    },
  },
};
</script>
<style scoped>
.body-wrap {
  overflow: hidden;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  width: 100%;
  margin-bottom: 100px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  /* height: 966px; */
}

.bg-gold {
  background: linear-gradient(rgb(231, 211, 157), rgb(177, 149, 96)) !important;
}
#tblWithdraw {
  width: 100%;
}
/*
#tblWithdraw td, #tblWithdraw th
{
text-align:center;
}
*/
.gamename {
  /*text-align:left;*/
  font-size: small;
}

.gamebalance {
  text-align: right;
}

/*table.table-striped > thead > tr > th, table.table-striped > tbody > tr > td{
          border:1px solid blue;
        }*/
#tblWithdraw tbody tr,
#tblWithdraw thead tr {
  color: white;
  /* border-bottom: 1px solid #876c35cc !important; */
  /*border: 1px solid #876c35cc;*/
}

/* .table th,  */

table th {
  border-top: 1.5px solid transparent !important;
  border-bottom: 1.5px solid transparent !important;
  vertical-align: middle;
}
.table td {
  /* border-top: 1.5px solid #876c35cc !important; */

  border-top: 1.5px solid transparent !important;
  border-bottom: 1.5px solid #036684 !important;
  vertical-align: middle;
}

.gamebalance {
  font-weight: bold;
}

.TransferButton {
  /*background: linear-gradient(to bottom, #e7d39d, #b19560);*/
  background: gray;

  color: white;
  text-align: center;
  padding: 5px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  white-space: nowrap;
  font-size: small;
  -webkit-appearance: button;
  border: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
}

.TransferButton img {
  width: 20px;
  height: 20px;
  margin-left: 2px;
  margin-right: 5px;
  margin-top: 1px;
  margin-bottom: 1px;
}

.TransferButton span {
  margin-right: 2px;
}
/* Absolute Center Spinner */
.loading {
  position: fixed;
  width: 50px;
  height: 50px;
  display: inline-block;
  overflow: show;
  margin: auto;
  top: 28rem;
  left: 0;
  bottom: 0;
  right: 0;
  /* z-index: 1; */
}

div.loading div {
  width: 6%;
  height: 16%;
  background: #fff;
  position: absolute;
  left: 49%;
  top: 43%;
  opacity: 0;
  -webkit-border-radius: 50px;
  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  -webkit-animation: fade 1s linear infinite;
}

.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(rgba(20, 20, 20, 0.8), rgba(0, 0, 0, 0.8));
  background: -webkit-radial-gradient(
    rgba(20, 20, 20, 0.8),
    rgba(0, 0, 0, 0.8)
  );
}

.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: '';
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
}

@-webkit-keyframes fade {
  from {
    opacity: 1;
  }

  to {
    opacity: 0.25;
  }
}

.loading div.bar1 {
  -webkit-transform: rotate(0deg) translate(0, -130%);
  -webkit-animation-delay: 0s;
}

.loading div.bar2 {
  -webkit-transform: rotate(30deg) translate(0, -130%);
  -webkit-animation-delay: -0.9167s;
}

.loading div.bar3 {
  -webkit-transform: rotate(60deg) translate(0, -130%);
  -webkit-animation-delay: -0.833s;
}

.loading div.bar4 {
  -webkit-transform: rotate(90deg) translate(0, -130%);
  -webkit-animation-delay: -0.7497s;
}

.loading div.bar5 {
  -webkit-transform: rotate(120deg) translate(0, -130%);
  -webkit-animation-delay: -0.667s;
}

.loading div.bar6 {
  -webkit-transform: rotate(150deg) translate(0, -130%);
  -webkit-animation-delay: -0.5837s;
}

.loading div.bar7 {
  -webkit-transform: rotate(180deg) translate(0, -130%);
  -webkit-animation-delay: -0.5s;
}

.loading div.bar8 {
  -webkit-transform: rotate(210deg) translate(0, -130%);
  -webkit-animation-delay: -0.4167s;
}

.loading div.bar9 {
  -webkit-transform: rotate(240deg) translate(0, -130%);
  -webkit-animation-delay: -0.333s;
}

.loading div.bar10 {
  -webkit-transform: rotate(270deg) translate(0, -130%);
  -webkit-animation-delay: -0.2497s;
}

.loading div.bar11 {
  -webkit-transform: rotate(300deg) translate(0, -130%);
  -webkit-animation-delay: -0.167s;
}

.loading div.bar12 {
  -webkit-transform: rotate(330deg) translate(0, -130%);
  -webkit-animation-delay: -0.0833s;
}

.btn-danger {
  background-color: #3ab54a !important;
  color: white;
  border: 1px solid white !important;
  border-radius: 20px;
  width: 140px;
}

.spinner-color {
  background: gray;
}

body {
  background-color: #2a2a2a;
}

td:last-child {
  text-align: -webkit-right;
}

table {
  position: relative;
  top: 2px;
}

.table td,
.table th {
  padding: 0.85rem;
}

.btn-cashout {
  background: linear-gradient(to bottom, #00edff, #22a4dd);
  /* min-width: 110px; */
  padding: 5px;
  min-width: 6.5rem;
}
.btn-cashout:disabled {
  opacity: 0.5;
}

.btn-restore {
  background: url(../../../assets/images/btn-restore.png) 0 0 / cover;
  padding: 5px 15px;
  height: 33px;
}

thead {
  background-color: #001e3c;
}

tr th {
  font-size: 14px;
  line-height: 1.14;
  color: #0fcdf0;
  font-weight: 400;
}
.text-restore {
  /* position: relative;
  top: -1.5px; */
  line-height: 1.19;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  color: #fff;
}

.icn-restore {
  /* position: relative;
  top: -1px; */
  margin-right: 0.5rem;
  padding: 0.2rem;
  object-fit: contain;
}

.text-cashout {
  line-height: 1.19;
  /* font-family: Helvetica; */
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  color: #2b2b32;
  position: relative;
  top: 0.05rem;
}

.text-restore {
  position: relative;
  top: -1.5px;
  line-height: 1.19;
  /* font-family: Helvetica; */
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  position: relative;
  top: 0.05rem;
}

.icn-cashout {
  position: relative;
  top: 1px;
  height: 15.1px;
  width: 16.4px;
  object-fit: contain;
}

.icn-restore {
  position: relative;
  top: 0px;
  height: 13.1px;
  margin-right: 0.1rem;
  object-fit: contain;
}

.btn-warning {
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.5) !important;
  text-shadow: 0 1px 1px rgba(254, 235, 203, 0.5);
  line-height: 1.25;
  border: 0px !important;
}

.border-top-bottom-none {
  border-top: 0px !important;
  border-bottom: 0px !important;
}

/* small screen */
@media (max-width: 320px) {
  .btn-cashout {
    min-width: 30px;
    padding: 6px 2px;
  }

  .btn-restore {
    padding: 6px 2px;
  }
}
.dim {
  background: #00000080;
}
</style>
